// src/components/legalConsentGate.js
//
// Pure (JSX-free) gate for the clickwrap consent flow, extracted so the
// compliance invariant is unit-testable under `node --test` (mirrors packType.js):
// in firebase/emulator mode a user can NEVER be "consented" unless EVERY required
// legal-doc version actually loaded -- a failed/empty /legalDocuments read must
// keep signup AND payment (checkout / PayMe submit) blocked, never bypass them.
// In mock mode there is no backend to load from, so the UI flow gates on the
// checkboxes alone (pre-existing behaviour, unchanged).

// Are all required legal-doc versions present? `versions` is the {type: version}
// map from useLegalDocs; empty on a failed read AND on an unseeded database.
export function legalConsentReady(versions, requireTypes, isMock) {
    if (isMock) return true;
    const v = versions || {};
    return (requireTypes || []).every((ty) => !!v[ty]);
}
